// extracted by mini-css-extract-plugin
export default {"popover":"popover_popover__e78lC"};